export default "__VITE_ASSET__APm_zu3z__"